import { ChangeDetectorRef, Component, ElementRef, EventEmitter, inject, Input, Output, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { Modal } from 'bootstrap';

@Component({
  selector: 'app-error-modal',
  templateUrl: './error-modal.component.html',
  styleUrls: ['./error-modal.component.scss']
})
export class ErrorModalComponent {
  @Input() errorMessage: string = '';
  errorModal: any;
  redirection:boolean = false;
  redirectionURL:string = '';
  public router = inject(Router);
  @Output() setScreen = new EventEmitter<boolean>();
  private cdr = inject(ChangeDetectorRef);
  private elRef = inject(ElementRef);
  nominee:boolean = false;
  locationReload: boolean = false;
  ngOnInit(){
    this.setScreen.emit(false);
  }

  // ngOnChanges(changes:SimpleChanges){
  //   if(changes['errorMessage'])
  //     this.errorMessage = changes['errorMessage'].currentValue;
  //     console.log(this.errorMessage,"this.errorMessage");
  //   }


  ModalShow(mess:string,redirect?:boolean,redirectUrl?:string,nominee?:boolean){
    if(mess){
      this.errorMessage = mess;
      this.cdr.detectChanges();
    }
    if(redirect && redirectUrl){
      this.redirection = true;
      this.redirectionURL = redirectUrl;
      this.setScreen.emit(true);
    }
    if(redirectUrl && redirectUrl === "/register"){
      this.locationReload = true;
    }
    if(nominee){
      this.nominee = true;
    }
    if(this.errorMessage){
      const element = this.elRef.nativeElement.querySelector('#exampleModal') as HTMLElement;
      if(element){
        this.errorModal = new Modal(element, {backdrop: 'static', keyboard: false});
        this.errorModal.show();
      }
      this.cdr.detectChanges();
    }
      
  }

  ModalHide(){
    this.errorMessage = "";
    const element = this.elRef.nativeElement.querySelector('#exampleModal') as HTMLElement;
    if (element) {
      this.errorModal = new Modal(element, {backdrop: 'static', keyboard: false});
      this.errorModal.hide();
    }
    const ele = document.getElementsByClassName('modal-backdrop');
    const $body = document.getElementsByTagName('body');
    if($body.length >= 1){
      for(let i=0;i<$body.length;i++){
        if($body[i].classList.contains("modal-open")){
          $body[i].classList.remove("modal-open")
        }
        $body[i].style.overflowY = "scroll";
      }
    }
    if(ele.length >= 1){
      for(let i=0;i<ele.length;i++){
        if(ele[i].classList.contains("show")){
          ele[i].classList.remove("show")
          ele[i].parentNode?.removeChild(ele[i]);
        }
      }
    }
    setTimeout(() => {
      if(this.locationReload){
        sessionStorage.clear();
        location.reload();
      }
      if(this.redirection && !this.locationReload){
        this.router.navigate([this.redirectionURL], { replaceUrl: true });
      }
    }, 100);
    
    

  }

}
